export const ExpertsList = [
    {
        username: "ilya_polikrpov",
        name: "Илья Поликарпов",
        photo: "/images/ilya_polikrpov.jpg",
        description: "В 2020 году титул «Бариста года» и премию по итогам одноименного чемпионата получил Илья Поликарпов. В настоящее время Илья – независимый бариста с богатым опытом работы.",
    },
    {
        username: "sostoyanie_the_mood",
        name: "Рустам Гайнутдинов",
        photo: "/images/sostoyanie_the_mood.jpg",
        description: "Эксперт по китайским чаям.",
    },
    {
        username: "Gywinka",
        name: "Елена Гущина",
        photo: "/images/Gywinka.jpg",
        description: "Судья чемпионатов бариста, тренер Латте арт, подготовка к чемпионатам.",
    },
    {
        username: "bowschool",
        name: "Павел Лапшин",
        photo: "/images/bowschool.jpg",
        description: "Бизнес консультант индустрии кофе, основатель школы бариста Bowschool.",
    },
    {
        username: "nasim_nozirov",
        name: "Насим Нозиров",
        photo: "/images/nasim_nozirov.jpg",
        description: "SCA-trainer, Q instructor, Q arabica grader.",
    },
];
